"use client";
import React from "react";
import { motion } from "framer-motion";
import {
  FaCheckCircle,
  FaUserTie,
  FaRegFileAlt,
  FaUsers,
  FaLightbulb,
  FaLaptopCode,
} from "react-icons/fa";
import { MdAccessTime } from "react-icons/md";

const modules = [
  "Letter Writing",
  "Report Writing",
  "Technical Report Writing",
  "Personality Development",
  "Resume",
  "Presentation Skills",
  "Oral Reporting",
  "Time Management",
  "Assertiveness",
  "Psychometric",
  "Creative Thinking",
  "Stress Management",
  "Group Discussion",
  "Interview Skills",
  "Computer and Internet Skills",
  "Entrepreneurial Skills",
  "Personality Development",
];

const highlights = [
  { icon: <FaRegFileAlt />, text: "Professional Writing" },
  { icon: <FaUserTie />, text: "Interview & Resume Skills" },
  { icon: <FaUsers />, text: "Group Discussions" },
  { icon: <MdAccessTime />, text: "Time & Stress Management" },
  { icon: <FaLightbulb />, text: "Creative & Entrepreneurial Thinking" },
  { icon: <FaLaptopCode />, text: "Digital & Technical Skills" },
];

const CareerLab = () => {
  return (
    <div className="bg-white text-dark mr-50 ml-50">
      {/* Header Section */}
      <section className=" ">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="display-4 fw-bold text-primary"
        >
          Career Lab
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="mt-3 fs-5 text-black"
        >
          The Career Lab develops{" "}
          <span className="fw-semibold">essential employability skills</span>{" "}
          sought by employers. It covers resume writing, report writing, group
          discussions, interview skills, time management, and entrepreneurial
          skills to ensure success in the recruitment process.
        </motion.p>
      </section>

      {/* Highlights Section */}
      <section className=" py-3">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="h2 fw-bold text-primary text-center mb-4"
        >
          Key Learning Highlights
        </motion.h2>

        <div className="row g-4">
          {highlights.map((item, idx) => (
            <div className="col-sm-6 col-md-4" key={idx}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                viewport={{ once: true }}
                className="card border-0 shadow h-100 text-center p-4"
              >
                <div className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center justify-content-center mb-3"
                  style={{ width: "60px", height: "60px", fontSize: "1.5rem" }}>
                  {item.icon}
                </div>
                <span className="fw-medium">{item.text}</span>
              </motion.div>
            </div>
          ))}
        </div>
      </section>

      {/* Modules Section */}
      <section className=" py-5">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="p-4 rounded shadow border-start border-4 border-primary bg-light"
        >
          <h3 className="h4 fw-semibold text-primary mb-3">
            Modules Covered
          </h3>
          <div className="row g-3">
            {modules.map((mod, idx) => (
              <div className="col-sm-6 col-md-4 mt-2" key={idx}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: idx * 0.05 }}
                  viewport={{ once: true }}
                  className="d-flex align-items-start bg-white shadow-sm rounded p-2 h-100"
                >
                  <FaCheckCircle className="text-success me-2 mt-1" />
                  <span className="text-black">{mod}</span>
                </motion.div>
              </div>
            ))}
          </div>
        </motion.div>
      </section>

      {/* Advantages Section */}
      <section className=" text-white py-5" style={{ backgroundColor: "#0a1530" }}>
        <div className="container text-center">
          <motion.h2
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="h2 fw-bold"
          >
            Advantages of Career Lab
          </motion.h2>
          <div className="row g-4 mt-4 text-start">
            {[
              "Boosts employability",
              "Covers all-round skills",
              "Enhances confidence & personality",
            ].map((adv, idx) => (
              <div className="col-sm-6 col-md-4" key={idx}>
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: idx * 0.1, duration: 0.6 }}
                  viewport={{ once: true }}
                  className="bg-white bg-opacity-25 p-3 rounded d-flex align-items-start"
                >
                  <FaCheckCircle className="text-success me-2 mt-1" />
                  <span className="text-white" >{adv}</span>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CareerLab;
